import HttpAgent, { HttpsAgent } from 'agentkeepalive';
export const httpAgent = new HttpAgent();
export const httpsAgent = new HttpsAgent();